import { useResolveRoute } from '@mews/routing';
import { CorrectedOrderItem } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { ModalLink } from '../../../../components';

type CorrectionBillOrderItemActionLogLinkProps = Pick<CorrectedOrderItem, 'name' | 'id' | 'billId'>;

export const CorrectionBillOrderItemActionLogLink = ({
    name,
    id,
    billId,
}: CorrectionBillOrderItemActionLogLinkProps) => {
    const resolveRoute = useResolveRoute();

    const url = resolveRoute(RouteName.OrderItemActionLog, { id, billId });

    return (
        <ModalLink url={url} data-test-order-item-action-log-link={id}>
            {name}
        </ModalLink>
    );
};
